import React from "react";
import "./WhatsappIcon.scss";

const WhatsappIcon = () => {
  return (
    <div id="whatsapp">
      <a
        href="http://wa.me/5515991760482"
        target="_blank"
        rel="noopener noreferrer"
        className="wtsapp"
      >
        <i className="fa fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default WhatsappIcon;
